var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component--charging_rate_details"},[_c('div',{staticClass:"inner-wrap"},[_c('List',{attrs:{"action":_vm.action,"path":'charging_rate_detail',"defaultFilter":{chargingRateId:_vm.id},"defaultData":{chargingRateId:_vm.id}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }